import {
  ReactNode,
  useCallback,
  useState,
} from 'react'
import cn from 'classnames'

import Text from 'components/typography/Text'

export interface Props {
  title: string
  titleButtons?: ReactNode
  children: ReactNode
}

function Block({
  title,
  titleButtons,
  children,
}: Props) {

  return (
    <div className={cn(
      'flex-1',
      'flex',
      'flex-col',
      'rounded-lg',
      'drop-shadow-xl',
      'transition-all',
      'bg-black-850'
    )}>
      <div
        className={cn(
          'h-[38px]',
          'px-2',
          'bg-gray-800',
          'flex',
          'items-center',
          'justify-between',

          'group',
          'transition-all',
        )}
      >
        {!titleButtons ? (
          <Text
            color="text-gray-500 dark:text-gray-800"
            text={title}
            typeface={Text.typeface.BarlowSemibold}
          />
        ) : (
          <div
            className="
              flex
              items-center
              space-x-2
            "
          >
            <Text
              className="uppercase"
              text={title}
            />
            {titleButtons}
          </div>
        )}
      </div>

      <div className={cn(
        'flex-1',
        'flex',
        'flex-col',
        'relative'
      )}>{children}</div>
    </div>
  )
}

export default Block
